import { render, staticRenderFns } from "./Grab.vue?vue&type=template&id=39e3fc6e"
import script from "./Grab.vue?vue&type=script&lang=js"
export * from "./Grab.vue?vue&type=script&lang=js"
import style0 from "./Grab.vue?vue&type=style&index=0&id=39e3fc6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports